import * as React from "react";

export type LabeledFilterFieldProps = {
  label: string;
  htmlFor?: string;
  /** Fundo do recorte do label (igual ao fundo da página). */
  labelBgClass?: string;
  className?: string;
  children: React.ReactNode;
};

export function LabeledFilterField({
  label,
  htmlFor,
  labelBgClass = "period-filter-label-bg",
  className = "",
  children,
}: LabeledFilterFieldProps) {
  return (
    <div className={`relative shrink-0 ${className}`.trim()}>
      <label
        htmlFor={htmlFor}
        className={`pointer-events-none absolute left-3 top-0 z-10 -translate-y-1/2 whitespace-nowrap px-1 text-xs leading-none text-muted-foreground ${labelBgClass}`}
      >
        {label}
      </label>
      {children}
    </div>
  );
}
